<template>
  <div class="container">
    <div class="field is-grouped">
      <div class="control is-expanded">
        <label class="label">First Name</label>
        <input type="text" class="input" v-model="user.firstName" />
      </div>
      <div class="control is-expanded">
        <label class="label">Last Name</label>
        <input type="text" class="input" v-model="user.lastName" />
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="label">Email</label>
        <input type="email" class="input" v-model="user.email" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">LinkedIn Profile</label>
        <input type="email" class="input" v-model="user.linkedinProfile" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">What is your primary affiliation?</label>
        <textarea class="textarea" v-model="user.evaluatorAffiliation" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">Why do you want to join?</label>
        <textarea class="textarea" v-model="user.evaluatorWhyJoin" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">What are your qualifications?</label>
        <textarea class="textarea" v-model="user.evaluatorQualifications" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">How did you find out about us?</label>
        <textarea class="textarea" v-model="user.evaluatorHowFindOut" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">What are your main interests?</label>
        <textarea class="textarea" v-model="user.evaluatorMainInterests" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">Status</label>
        <div class="select">
          <select v-model="user.status">
            <option v-for="(status, value) in statuses" :key="value" :value="value">{{
              status
            }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button" @click="addUser">
          Submit
        </button>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button" @click="addMultipleUsers">
          Submit and Add Another
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users/'

export default {
  data() {
    return {
      user: User.create(),
      addAnother: false,
      pendingAsEvaluator: false,
      statuses: User.evaluatorStatuses,
    }
  },
  created() {},
  methods: {
    addMultipleUsers() {
      this.addAnother = true
      this.addUser()
    },
    addUser() {
      this.user.isEvaluator = true
      const fields = [
        'firstName',
        'lastName',
        'isEvaluator',
        'pendingAsEvaluator',
        'email',
        'evaluatorAffiliation',
        'evaluatorWhyJoin',
        'evaluatorQualifications',
        'evaluatorHowFindOut',
        'evaluatorMainInterests',
        'linkedinProfile',
        'status'
      ]
      User.api
        .create(this.user, fields)
        .then(() => {
          this.$Alert.alert({
            type: 'success',
            message: `<p>Evaluator Created<p>`,
            timeout: 6000,
          })
          if (!this.addAnother) {
            this.$router.push({ name: 'EvaluatorsOverview' })
          } else {
            this.user = User.create()
            this.addAnother = false
          }
        })
        .catch(errors => {
          this.$Alert.alert({
            type: 'error',
            message: `<p>Creation failed. Check to make sure all fields are formatted properly.</p>`,
            timeout: 6000,
          })
        })
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 2px;
}
.fa {
  margin: 0 2px;
}
</style>
